import { schema } from "normalizr"

export default new schema.Entity("imports", {}, { idAttribute: "importId" })
